import http from "../httpcommon";
import httpcommon from "../httpCommon1";

class NotificationScreens {
  getNotification(params) {
    return httpcommon.post(`notification/getNotificationList`, params);
  }

  getNotificationSend(params) {
    return httpcommon.post(`notification/getNotificationList`, params);
  }

  sendNotification(payload) {
    return httpcommon.post(`notification/createNotification`, payload);
  }

  getEmailSent(emailId) {
    const payload = {
      fromCode: emailId
    };
    return httpcommon.post(`notification/listMailsForUserPage`, payload);
  }

  getEmailByCode(toCode) {
    const payload = {
      toCode: toCode
    };
    return httpcommon.post(`notification/listMailsForUserPage`, payload);
  }

  sendFeedback(payload) {
    return http.post(`notification/createFeedback`, payload);
  }

  sendMail(payload) {
    return httpcommon.post(`notification/createMail`, payload);
  }

  searchData(payload) {
    return httpcommon.post(`dropdown/patient/list`, payload);
  }

  searchFamilyData(payload) {
    return httpcommon.post(`dropdown/patientFamily/list`, payload);
  }
}

export default new NotificationScreens();